var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 4.57142857e-05 29.5264 4.57142857e-05 29.5264 28.3424457 0 28.3424457"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category",
    transform: "translate(-444.000000, -176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    transform: "translate(446.500000, 184.000000) rotate(-90.000000) translate(-446.500000, -184.000000) translate(431.500000, 169.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "done_ic-green",
    mask: "url(#mask-2)",
    fill: "#DBDBDB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000267, -0.000411)",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4966667,13.6 L16.71,19.4 L16.1366667,19.96 C15.9366667,20.1466667 15.67,20.2666667 15.3766667,20.2666667 C15.1233333,20.2666667 14.8833333,20.1733333 14.6966667,20.0266667 L8.27,13.6 C7.91,13.2266667 7.91,12.64 8.27,12.28 C8.63,11.9066667 9.23,11.9066667 9.59,12.28 L15.39,18.08 L21.1766667,12.28 C21.5366667,11.9066667 22.1233333,11.9066667 22.4966667,12.28 C22.67,12.4533333 22.7633333,12.6933333 22.7633333,12.9333333 C22.7633333,13.1733333 22.67,13.4133333 22.4966667,13.6 Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightArrow);
export default __webpack_public_path__ + "static/media/ic_right_arrow.4a087617.svg";
export { ForwardRef as ReactComponent };